import { Box } from 'app/components/design-system-components'
import TextSpan from 'app/components/design-system-components/TextSpan'
import { Heading } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'
import type { RentalHistoryFormValues } from 'app/profile/renter/refactor_rental_history/components/RentalHistoryForm/types'
import DocumentList from 'app/shared_components/document_list/document_list'
import { DocumentTypes } from 'app/sm/helpers'

// Simple device detection helper
const isMobile = () => window.innerWidth <= 768

interface DocumentSectionProps {
  values: RentalHistoryFormValues
  removeLedgerAttachment: (guidID: string) => void
  uploadLedgerAttachment: (documentType: string) => void
  isLoading?: boolean
}

/**
 * Document section component
 * Handles rental ledger upload and management
 */
export const DocumentSection = ({
  values,
  removeLedgerAttachment,
  uploadLedgerAttachment,
  isLoading = false,
}: DocumentSectionProps) => {
  const handleUploadDocument = (documentType: string) => {
    uploadLedgerAttachment(documentType)
  }

  const handleDeleteDocument = (attachmentId: string, event?: any) => {
    // Prevent any event bubbling that might cause form submission or navigation
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    // Use a wrapped function to ensure no additional parameters are passed
    removeLedgerAttachment(attachmentId)
  }

  return (
    <Box my={7}>
      <Heading level={3} displayingLevel={3} mb={4}>
        Rental Ledger{' '}
        <span style={isMobile() ? { fontSize: theme.fontSizes.pLarge16 } : {}}>
          (Highly Recommended)
        </span>
      </Heading>

      <Box mb={5}>
        <TextSpan>Add the applicant’s previous address</TextSpan>
      </Box>

      <DocumentList
        showUploader={values.ledgerAttachments.length < 1}
        disableMultiple
        documents={values.ledgerAttachments}
        addDocument={handleUploadDocument}
        deleteDocument={handleDeleteDocument}
        documentType={DocumentTypes.rentalLedger}
        spinner={isLoading}
        fileType="RentalLedger"
        toggleDocumentsViewer={undefined}
        disabledUpload={isLoading}
        isFromAgencyBranding={false}
      />
    </Box>
  )
}
